/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from "../icetypes";

export class otheritemsindex extends IceEntity {
  other_items_index_key: string = "";
  other_items_key: string = "";
  item_stock_num: string = "";
  tax_status: IceTypes.sales_tax_status = IceTypes.sales_tax_status.stsNonTaxable;
  sku_num: string = "";
  itm_name: string = "";
  itm_desc: string = "";
  service_option: boolean = false;
  cosmetic_option: boolean = false;
  code: string = "";
  code_list_qualifier_code: string = "";
  code_txt: string = "";
  cost: number = 0.0;
  price: number = 0.0;
  net: number = 0.0;
  unit_type: string = "";

  constructor() {
    super();
  }

  gettablename(): string {
  return "OTHER_ITEMS_INDEX";
  }
}
